/*
 * @Author: liangzhaozhang
 * @Date: 2022-02-28 15:39:52
 * @Last Modified by: liangzhaozhang
 * @Last Modified time: 2022-05-21 18:24:44
 */

import {
  initAxios,
  createBaseRequest,
  createBaseRequestWithOutReturnResponse,
} from 'open-platform-utils';
import { Toast } from '@douyinfe/semi-ui';

// 初始化 axios 实例
const axios = initAxios({});

export const showMessageWithStatus = (status: number | string): void => {
  let message = '';
  switch (status) {
    case 400:
      message = '请求错误 (400)';
      break;
    case 401:
      message = '未授权，请重新登录 (401)';
      break;
    case 403:
      message = '拒绝访问 (403)';
      break;
    case 404:
      message = '请求出错 (404)';
      break;
    case 408:
      message = '请求超时 (408)';
      break;
    case 500:
      message = '服务器错误 (500)';
      break;
    case 501:
      message = '服务未实现 (501)';
      break;
    case 502:
      message = '网络错误 (502)';
      break;
    case 503:
      message = '服务不可用 (503)';
      break;
    case 504:
      message = '网络超时 (504)';
      break;
    case 505:
      message = 'HTTP 版本不受支持 (505)';
      break;
    default:
      message = `连接出错 (${status})!`;
  }
  Toast.destroyAll();
  Toast.error(message);
};

export const showMessageWithMsg = (message: string): void => {
  if (!message) {
    return;
  }
  Toast.destroyAll();
  Toast.error(message);
};

axios.interceptors.response.use(
  response => {
    if (response.status === 200) {
      // TODO: 兼容处理没有 error 的情况
      // if (!response.data.error) {
      //   // 处理接口异常
      //   showMessageWithMsg(response.data.message);
      // }
      return response;
    } else {
      // showMessageWithStatus(response.status);
      return response;
    }
  },
  (error: any) => {
    const { response } = error;
    if (response) {
      // 请求已发出，但是不在 2xx 的范围
      // showMessageWithStatus(response.status);
      return Promise.reject(response);
    } else {
      // Toast.error('网络连接异常，请稍后再试！');
      return Promise.reject(error);
    }
  },
);

export const request = createBaseRequest(axios);
export const requestServerV1 = createBaseRequestWithOutReturnResponse(axios);
export const requestAweme = createBaseRequestWithOutReturnResponse(axios);
